export default (state = [], action) => {
    let { type, payload } = action
    switch (type) {
        case 'HUNT_PLANNER_ACTIVE_SELECTED_OPTIONS':
            return payload
        case 'LOGOUT':
            return []
        default:
            return state
    }
}
